import styled from "styled-components";

const FooterWrapper = styled.footer`
    padding-top: 2%;
    text-align: center;
`;
const CopyrightWrapper = styled.div`
    color: white;
    min-height: 3rem;
    font-weight: 200;
`;
export { FooterWrapper, CopyrightWrapper };
